export default __webpack_public_path__ + "static/recipes-03-img-ee5f2a808dbb33c62d1a6ce71f0d55af.png";